/** Цвет Label по сырому статусу Order Management API Avito (как mapApiStatusToCategory на бэкенде). */
export function getAvitoPostingStatusLabelColor(
  raw: string | null | undefined
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  const s = String(raw ?? '').trim().toLowerCase();
  if (['on_confirmation', 'ready_to_ship'].includes(s)) return 'default';
  if (s === 'in_transit') return 'warning';
  if (['delivered', 'closed'].includes(s)) return 'success';
  if (['cancelled', 'on_return', 'in_dispute'].includes(s)) return 'error';
  return 'default';
}

/** Строка для тултипов/экспорта без i18n (читаемый snake_case). */
export function formatAvitoPostingStatusLabel(raw: string | null | undefined): string {
  if (raw == null || raw === '') return '—';
  return String(raw)
    .trim()
    .split('_')
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(' ');
}
